import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { GridViewComponent } from './grid-view.component';
import { TableViewModule } from '../table-view';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { TranslateModule } from '@ngx-translate/core';
import { ArrowNavigationModule } from '../../directives/arrow-navigation';
import { DragSelectionModule } from '../../directives/drag-selection';
import { GridViewCellModule } from '../grid-view-cell';

@NgModule({
  declarations: [GridViewComponent],
  imports: [CommonModule, DragDropModule, TableViewModule, TranslateModule, DragSelectionModule, ArrowNavigationModule, GridViewCellModule],
  exports: [GridViewComponent, TableViewModule],
})
export class GridViewModule {}
